import {
  GET_METRICS,
  GET_METRICS_ERROR,
  GET_METRICS_SUCCESS,
} from './Metrics.actions';

const initialState = {
  data: [],
  loading: true,
  error: undefined,
};

/**
 * The Metrics Reducer.
 */
const metricsReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case GET_METRICS: {
      return { ...state, loading: true, error: undefined }; // Set loading to true
    }
    case GET_METRICS_ERROR: {
      return { ...state, loading: false, error: payload.error }; // Set error and loading to false
    }
    case GET_METRICS_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: undefined,
        data: payload.data, // Save the data to the state
      };
    }
    default: {
      return state; // Default case to return the unchanged state
    }
  }
};

export default metricsReducer;
